module.exports = __webpack_public_path__ + "img/client-15.53c8fa7f.png";